import React from 'react'
import { IconType } from './types'

// Icons joined
import IconCircle from './images/joinedIcons/iconCircle'
import IconOval from './images/joinedIcons/iconOval'
import IconRectangle from './images/joinedIcons/iconRectangle'
import IconConcaveCylinder from './images/joinedIcons/iconConcaveCylinder'
import IconHexagon from './images/joinedIcons/iconHexagon'
import IconRhombus from './images/joinedIcons/iconRhombus'
import IconClover from './images/joinedIcons/iconClover'
import IconRoundedRectangle from './images/joinedIcons/iconRoundedRectangle'

// Icons can join
import IconCircleCanJoin from './images/canJoinIcons/iconCircleCanJoin'
import IconOvalCanJoin from './images/canJoinIcons/iconOvalCanJoin'
import IconRectangleCanJoin from './images/canJoinIcons/iconRectangleCanJoin'
import IconConcaveCylinderCanJoin from './images/canJoinIcons/iconCancaveCylinderCanJoin'
import IconHexagonCanJoin from './images/canJoinIcons/iconHexagonCanJoin'
import IconRhombusCanJoin from './images/canJoinIcons/iconRhombusCanJoin'
import IconCloverCanJoin from './images/canJoinIcons/iconCloverCanJoin'
import IconRoundedRectangleCanJoin from './images/canJoinIcons/iconRoundedRectangleCanJoin'

// Icons complete
import IconCircleComplete from './images/completeIcons/iconCircleComplete'
import IconOvalComplete from './images/completeIcons/iconOvalComplete'
import IconRectangleComplete from './images/completeIcons/iconRectangleComplete'
import IconConcaveCylinderComplete from './images/completeIcons/iconConcaveCylinderComplete'
import IconHexagonComplete from './images/completeIcons/iconHexagonComplete'
import IconRhombusComplete from './images/completeIcons/iconRhombusComplete'
import IconCloverComplete from './images/completeIcons/iconCloverComplete'
import IconRoundedRectangleComplete from './images/completeIcons/iconRoundedRectangleComplete'

// Icons time
import IconCircleTime from './images/timeIcons/iconCircleTime'
import IconOvalTime from './images/timeIcons/iconOvalTime'
import IconRectangleTime from './images/timeIcons/iconRectangleTime'
import IconConcaveCylinderTime from './images/timeIcons/iconConcaveCylinderTime'
import IconHexagonTime from './images/timeIcons/iconHexagonTime'
import IconRhombusTime from './images/timeIcons/iconRhombusTime'
import IconCloverTime from './images/timeIcons/iconCloverTime'
import IconRoundedRectangleTime from './images/timeIcons/iconRoundedRectangleTime'

// Icons blocked
import IconCircleBlocked from './images/blockedIcons/iconCircleBlocked'
import IconOvalBlocked from './images/blockedIcons/iconOvalBlocked'
import IconRectangleBlocked from './images/blockedIcons/iconRectangleBlocked'
import IconConcaveCylinderBlocked from './images/blockedIcons/iconConcaveCylinderBlocked'
import IconHexagonBlocked from './images/blockedIcons/iconHexagonBlocked'
import IconRhombusBlocked from './images/blockedIcons/iconRhombusBlocked'
import IconCloverBlocked from './images/blockedIcons/iconCloverBlocked'
import IconRoundedRectangleBlocked from './images/blockedIcons/iconRoundedRectangleBlocked'

export default ({
  type,
  status,
  color,
  isFill,
  props,
}: IconType): JSX.Element => {
  const collection = {
    joined: {
      circle: <IconCircle isFill={isFill} color={color} props={props} />,
      oval: <IconOval isFill={isFill} color={color} props={props} />,
      rectangle: <IconRectangle isFill={isFill} color={color} props={props} />,
      concave_cylinder: (
        <IconConcaveCylinder isFill={isFill} color={color} props={props} />
      ),
      hexagon: <IconHexagon isFill={isFill} color={color} props={props} />,
      rhombus: <IconRhombus isFill={isFill} color={color} props={props} />,
      clover: <IconClover isFill={isFill} color={color} props={props} />,
      rounded_rectangle: (
        <IconRoundedRectangle isFill={isFill} color={color} props={props} />
      ),
    },
    default: {
      circle: <IconCircleCanJoin isFill={isFill} color={color} props={props} />,
      oval: <IconOvalCanJoin isFill={isFill} color={color} props={props} />,
      rectangle: (
        <IconRectangleCanJoin isFill={isFill} color={color} props={props} />
      ),
      concave_cylinder: (
        <IconConcaveCylinderCanJoin
          isFill={isFill}
          color={color}
          props={props}
        />
      ),
      hexagon: (
        <IconHexagonCanJoin isFill={isFill} color={color} props={props} />
      ),
      rhombus: (
        <IconRhombusCanJoin isFill={isFill} color={color} props={props} />
      ),
      clover: <IconCloverCanJoin isFill={isFill} color={color} props={props} />,
      rounded_rectangle: (
        <IconRoundedRectangleCanJoin
          isFill={isFill}
          color={color}
          props={props}
        />
      ),
    },
    complete: {
      circle: (
        <IconCircleComplete isFill={isFill} color={color} props={props} />
      ),
      oval: <IconOvalComplete isFill={isFill} color={color} props={props} />,
      rectangle: (
        <IconRectangleComplete isFill={isFill} color={color} props={props} />
      ),
      concave_cylinder: (
        <IconConcaveCylinderComplete
          isFill={isFill}
          color={color}
          props={props}
        />
      ),
      hexagon: (
        <IconHexagonComplete isFill={isFill} color={color} props={props} />
      ),
      rhombus: (
        <IconRhombusComplete isFill={isFill} color={color} props={props} />
      ),
      clover: (
        <IconCloverComplete isFill={isFill} color={color} props={props} />
      ),
      rounded_rectangle: (
        <IconRoundedRectangleComplete
          isFill={isFill}
          color={color}
          props={props}
        />
      ),
    },
    time: {
      circle: <IconCircleTime isFill={isFill} props={props} />,
      oval: <IconOvalTime isFill={isFill} props={props} />,
      rectangle: <IconRectangleTime isFill={isFill} props={props} />,
      concave_cylinder: (
        <IconConcaveCylinderTime isFill={isFill} props={props} />
      ),
      hexagon: <IconHexagonTime isFill={isFill} props={props} />,
      rhombus: <IconRhombusTime isFill={isFill} props={props} />,
      clover: <IconCloverTime isFill={isFill} props={props} />,
      rounded_rectangle: (
        <IconRoundedRectangleTime isFill={isFill} props={props} />
      ),
    },
    blocked: {
      circle: <IconCircleBlocked isFill={isFill} props={props} />,
      oval: <IconOvalBlocked isFill={isFill} props={props} />,
      rectangle: <IconRectangleBlocked isFill={isFill} props={props} />,
      concave_cylinder: (
        <IconConcaveCylinderBlocked isFill={isFill} props={props} />
      ),
      hexagon: <IconHexagonBlocked isFill={isFill} props={props} />,
      rhombus: <IconRhombusBlocked isFill={isFill} props={props} />,
      clover: <IconCloverBlocked isFill={isFill} props={props} />,
      rounded_rectangle: (
        <IconRoundedRectangleBlocked isFill={isFill} props={props} />
      ),
    },
  }

  if (type !== 'start' && type !== 'finish') {
    return collection[status][type]
  } else {
    return <></>
  }
}
